import { Button, Flex, Heading, Text } from '@chakra-ui/react';
import { FC } from 'react';

const NotFound: FC = () => {
  return (
    <Flex justifyContent={'center'} alignItems={'center'} flexDirection={'column'} height={'100svh'}>
      <Heading>404 Not found</Heading>
      <Button
        onClick={() => {
          window.close();
        }}
        colorPalette={'gray'}
        color={'white'}
      >
        Close
      </Button>
    </Flex>
  );
};
export default NotFound;
